import { render, staticRenderFns } from "./SubSidebar.vue?vue&type=template&id=5e1a0216&scoped=true&"
import script from "./SubSidebar.vue?vue&type=script&lang=js&"
export * from "./SubSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SubSidebar.vue?vue&type=style&index=0&id=5e1a0216&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1a0216",
  null
  
)

export default component.exports